(function () {
    'use strict';

    angular
        .module('controlEditModule')
        .controller('ControlTestObservationListController', Controller);

    Controller.$inject = ['$scope', '$state', 'historyCtxtService', 'controlTest', 'testResults'];

    function Controller($scope, $state, historyCtxtService, controlTest, testResults) {

        $scope.controlTest = controlTest;
        $scope.testResults = testResults;

        // Add Observation
        $scope.addObservation = function () {
            $state.go('observation.add', {
                ControlTestID: $scope.controlTest.ControlTestID
            });
        };

        // Add Observation
        $scope.hideAddObservation = function () {
            return _.isUndefined($scope.testResults.ActualTestResult);
        };

        // Edit Observation
        $scope.editObservation = function (item) {
            historyCtxtService.goToState('observation.edit',
                { ObservationID: item.ObservationID },
                'control',
                $scope.control
            );
        };
    }
})();